export default "__VITE_ASSET__43d98e8a__"